import type { GutXAxisOrgan } from '@repo/types';
import { useCallback } from 'react';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { organAnchorId } from 'views/Results/utils/organs';

/**
 * Picking an organ on this page's body map, which scrolls to its section rather
 * than navigating. The `source` is what separates this tap from the home card's.
 */
export function useOrganSelect() {
  const { trackEvent } = useAnalytics();

  return useCallback(
    (organ: GutXAxisOrgan) => {
      trackEvent('Conditions Organ Tapped', {
        organ_system: organ.lookup_code,
        source: 'conditions_home',
      });

      document
        .getElementById(organAnchorId(organ.lookup_code))
        ?.scrollIntoView({ behavior: 'smooth' });
    },
    [trackEvent],
  );
}

export default useOrganSelect;
